import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService, UserTypes } from 'src/app/services/auth/auth.service';
import { SignupService } from 'src/app/services/signup/signup.service';

import { debounceTime, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';

import UIDefaultTheme from 'src/themes';
import { ToastService } from 'src/app/services/toast/toast.service';
import { MaskPipe } from 'ngx-mask';
import Utils from 'src/app/helpers/utils';
import DDIOptions from 'src/app/data/ddi';
import { permission } from 'src/app/data/permissions';
import { StorageService } from 'src/app/services/storage/storage.service';
import { PendingApprovalService } from 'src/app/services/pending-approval/pending-approval.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dash-sidebar',
  templateUrl: './dash-sidebar.component.html',
  styleUrls: ['./dash-sidebar.component.scss'],
})
export class DashSidebarComponent implements OnInit, OnDestroy {
  @ViewChild('toggleOptions') toggleOptions: ElementRef;
  @ViewChild('toggleSwitch') toggleSwitch: ElementRef;

  newUserForm = this.formBuilder.group({
    role: [null, [Validators.required]],
    interest_fund: [null, []],
    agent: [null, []],
  });

  roleForm = this.formBuilder.group({
    role: [null, [Validators.required]],
  });

  changeBasicInfoForm = this.formBuilder.group({
    full_name: [null, [Validators.required]],
    email: [null, [Validators.required, Validators.email]],
    // phone_number: [null, [Validators.required, UtilsValidators.telefone]],
    phone_ddi: ['55', [Validators.required]],
  });
  changePasswordForm = this.formBuilder.group(
    {
      current_password: [null, [Validators.required, Validators.minLength(8)]],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          (control: FormControl) => {
            const password = control.value;

            if (!this.hasNumber(password)) return { noNumber: true };

            if (!this.hasLowerCase(password)) return { noLowerCase: true };

            if (!this.hasUpperCase(password)) return { noUpperCase: true };

            if (!this.hasSpecialCharacter(password))
              return { noSpecialCharacter: true };

            return null;
          },
        ],
      ],
      confirm_password: ['', [Validators.required]],
    },
    { validators: this.passwordsMatchValidator }
  );

  accounts: RegisterUserResponse[] = [];

  visible_accounts: any[] = [];
  switchAccontsLoading = true;

  selectedRegisterName: string = 'Sem vínculo com empresa';

  selectedRegisterDocument: string = '';

  selectedRegister: RegisterUserResponse = null;

  selectedRegisterRoles: any[] = [];

  currentRole: string = '';
  userArea: string = '';

  menu: MenuItem[] = [];

  submenu: MenuItem[] = [];

  switcherOpen = false;

  openNotify: boolean = false;
  userOptionsOpen: boolean = false;

  DDIOptions = DDIOptions;

  roleModal: boolean = false;
  roleSelectionModal: boolean = false;
  selectedUserForRoleSelection: any = null;

  form = this.formBuilder.group({
    search: [null, []],
  });

  searchOpen: boolean = false;

  subject: Subject<string> = new Subject();

  passwordSubmiting: boolean = false;
  basicInfoSubmiting: boolean = false;
  changePasswordStep: number = 0;

  columns: TableColumnList<UserProps>[] = [
    {
      name: 'Nome',
      cell: (row) => row.name,
      size: 2,
    },
    {
      name: 'Documento',
      cell: (row) => row.document,
    },
    {
      name: 'Papel',
      // row.role já vem com todos os papéis formatados, ex.:
      // "Cotista, Cotista Fundo de Investimento, Cedente"
      cell: (row) => `${row.role}`,
    },
  ];

  users: UserProps[] = [];

  notifications = [];
  haveNewNotifications: boolean = false;
  userCredentials: UserCredentials = {
    email: '',
    name: '',
  };

  is_approver = false;
  pendingCount: number = 0;
  isAdmin = false;
  sendingRequest = false;
  changePasswordShow = false;
  changeBasicInfoShow = false;
  searching = false;
  loadingMenu = true;
  loadingContent = true;
  private searchSubject = new Subject<string>();
  private currentSearchValue: string = '';
  private searchRequestId: number = 0;
  private isLoadingData = false; // Flag para evitar loop infinito
  private pendingApprovalSubscription?: Subscription;
  private searchSubjectSubscription?: Subscription;
  private searchValueChangesSubscription?: Subscription;

  newUserModal: boolean = false;
  roles: Role[] = [];
  primaryRoleOptions: SelectItem[] = [];
  fundOptions: SelectItem[] = [];
  roleOptions: SelectItem[] = [];
  filteredRoleOptions: SelectItem[] = [];

  userNacionality: string;
  userDocument: string;

  companyId: number = null;
  hasCompanyPermission: boolean = false;

  selectedApplicable: string = 'assignor';

  public UIDefaultTheme = UIDefaultTheme;
  isAccounts: boolean = false;
  isApprovalRoute: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    public signupService: SignupService,
    private formBuilder: FormBuilder,
    private api: ApiService,
    private toast: ToastService,
    private maskPipe: MaskPipe,
    private storageService: StorageService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private pendingApprovalService: PendingApprovalService
  ) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.toggleOptions?.nativeElement.contains(e.target)) {
        this.userOptionsOpen = false;
      }

      if (!this.toggleSwitch?.nativeElement.contains(e.target)) {
        this.switcherOpen = false;
      }
    });
  }

  ngOnInit(): void {
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     this.getPermissions();
    //   }
    // });

    try {
      this.checkApprovalRoute();
    } catch (error) {
      console.error('[DashSidebar] Erro em checkApprovalRoute():', error);
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkApprovalRoute();
        // Atualizar contagem de pendentes quando navegar para o dashboard
        if (this.router.url === '/app/dashboard') {
          // Verificar novamente se é aprovador
          if (this.authService.user.active_register) {
            const rolesToApprove = [
              'assignor',
              'provider',
              'shareholder',
              'fund',
            ];
            const hasApprovePermission = rolesToApprove.some((role) => {
              return this.authService.verifyPermission(
                `de_can_approve_${role}`
              );
            });

            this.is_approver =
              this.authService.user.is_superuser || hasApprovePermission;
          }

          // A atualização agora é automática via PendingApprovalService
          // Não precisa chamar manualmente aqui
        }
      });

    this.getData();

    // Usar a mesma fonte que o modal (authService.getUser()) e montar nome completo
    const user = this.authService.user || this.authService.getUser();
    this.userCredentials = {
      email: user?.email || '',
      name: user?.first_name 
        ? (user.first_name + (user.last_name ? ' ' + user.last_name : ''))
        : '',
    };
    this.signupService.fetchDataEvent.emit();

    this.isAdmin = false;
    user?.role &&
      user.role.applicable === 'admin' &&
      user.active_register === null;

    if (this.authService.user?.active_register) {
      const rolesToApprove = ['assignor', 'provider', 'shareholder', 'fund'];
      const hasApprovePermission = rolesToApprove.some((role) => {
        return this.authService.verifyPermission(`de_can_approve_${role}`);
      });

      this.is_approver =
        this.authService.user.is_superuser || hasApprovePermission;
    }

    // Se for usuário comum, chamar a API imediatamente para carregar o departamento
    if (this.isCommonCollaborator(user)) {
      // Chamar a API diretamente para garantir que o departamento seja carregado rapidamente
      this.getPendingCount();
    }

    // Subscrever ao serviço de aprovações pendentes para atualização automática
    this.pendingApprovalSubscription =
      this.pendingApprovalService.summary$.subscribe((summary) => {
        // Atualizar contagem para approver ou colaborador comum
        if (
          summary &&
          (this.is_approver || this.isCommonCollaborator(this.authService.user))
        ) {
          const departmentPending = summary.department_pending ?? 0;
          const totalByRole = summary.by_role?.total ?? 0;
          this.pendingCount =
            departmentPending > 0 ? departmentPending : totalByRole;
          
          // Armazenar a área retornada pela API (já filtrada)
          const rawArea = summary.area || '';
          this.userArea = this.filterUserArea(rawArea);
          
          // Atualizar o currentRole se for usuário comum
          const currentUser = this.authService.user || this.authService.getUser();
          if (this.isCommonCollaborator(currentUser)) {
            this.updateCommonUserRole();
          }
          
          this.cdr.detectChanges(); // Forçar detecção de mudanças
        }
      });

    this.authService.userChange.subscribe((user) => {
      // Se o usuário for undefined/null, não fazer nada (logout em andamento)
      if (!user) {
        return;
      }

      // Atualizar userCredentials quando o usuário mudar (mesma lógica do modal)
      this.userCredentials = {
        email: user.email || '',
        name: user.first_name 
          ? (user.first_name + (user.last_name ? ' ' + user.last_name : ''))
          : '',
      };

      // Só recarregar dados se não estiver já carregando (evita loop infinito)
      if (!this.isLoadingData) {
        this.getData();
      }
    });

    // Configurar debounce para busca (sem distinctUntilChanged para permitir
    // nova pesquisa ao digitar o mesmo termo de novo após limpar)
    this.searchSubjectSubscription = this.searchSubject
      .pipe(debounceTime(300))
      .subscribe((value) => {
        if (value && value.trim().length > 0) {
          this.searchUser(value);
        } else {
          this.users = [];
          this.searching = false;
        }
      });

    // Subscribe to form value changes and store subscription for cleanup
    this.searchValueChangesSubscription = this.form.controls.search.valueChanges.subscribe((value) => {
      if (value && value.trim().length > 0) {
        this.currentSearchValue = value;
        this.searching = true;
        this.searchSubject.next(value);
      } else {
        this.currentSearchValue = '';
        this.searchRequestId++;
        this.users = [];
        this.searching = false;
      }
    });

    if (this.authService.user) {
      this.getNotifications();
      setTimeout(() => {
        this.getNotifications();
      }, 3000);
    }

    this.newUserForm.controls.role.valueChanges.subscribe((value) => {
      const selectedRole = this.roles.find((item) => item.id === Number(value));

      this.selectedApplicable = selectedRole
        ? selectedRole.applicable
        : 'assignor';

      // Configurar validação do agente para prestador de serviço
      if (this.selectedApplicable === 'provider') {
        this.newUserForm.controls.agent.setValidators([Validators.required]);
      } else {
        this.newUserForm.controls.agent.setValidators([]);
      }

      // Configurar validação do fundo de interesse para cedente e cotista
      if (
        this.selectedApplicable === 'assignor' ||
        this.selectedApplicable === 'shareholder'
      ) {
        this.newUserForm.controls.interest_fund.setValidators([
          Validators.required,
        ]);
      } else {
        this.newUserForm.controls.interest_fund.setValidators([]);
      }

      this.newUserForm.controls.agent.setValue(null);
      this.newUserForm.controls.interest_fund.setValue(null);

      this.newUserForm.controls.agent.updateValueAndValidity();
      this.newUserForm.controls.interest_fund.updateValueAndValidity();
    });
  }

  async getPermissions() {
    try {
      const res = await this.api.get({
        route: 'api/v2/user_permission',
        token: true,
      });

      const permissionsArr =
        res.type_permission === 'owner' ? permission : res.permissions;
      this.authService.permissions = permissionsArr;
      this.storageService.set('permissions', permissionsArr, true);
      this.authService.permissionsLoadedEvent.emit();
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao carregar as permissões.'
      );
    }
  }

  async getData() {
    // Evitar múltiplas chamadas simultâneas
    if (this.isLoadingData) {
      return;
    }

    // Verificar se o usuário existe antes de fazer qualquer coisa
    if (!this.authService.user) {
      this.loadingContent = false;
      return;
    }

    this.isLoadingData = true;
    this.loadingContent = true;

    try {
      const token = await this.authService.getToken();

      // Verificar novamente se o usuário ainda existe (pode ter sido limpo)
      if (!this.authService.user) {
        this.isLoadingData = false;
        return;
      }

      // Buscar dados do usuário atual (sem atualizar o usuário para evitar loop)
      const userData = await this.getUserMe(false);

      // Verificar novamente após a chamada
      if (!this.authService.user) {
        this.isLoadingData = false;
        return;
      }

      // Garantir que os dados estejam disponíveis antes de continuar
      if (userData) {
        // Tentar obter a área do summary atual do serviço se ainda não tiver
        const currentSummary = this.pendingApprovalService.getCurrentSummary();
        if (currentSummary?.area && !this.userArea) {
          const rawArea = currentSummary.area;
          this.userArea = this.filterUserArea(rawArea);
        }
        
        // Atualizar os valores diretamente com os dados retornados
        this.updateRegisterDisplay(userData);
        
        // Atualizar userCredentials com os dados atualizados da API (mesma lógica do modal)
        this.userCredentials = {
          email: userData.email || '',
          name: userData.first_name 
            ? (userData.first_name + (userData.last_name ? ' ' + userData.last_name : ''))
            : '',
        };
      }

      await Promise.all([
        this.getSwitchMainAccount(),
        this.getSwitchAccounts(),
        this.handleSetMenu(),
      ]);

      // Se não setou os valores ainda, chamar changeActiveRegisterName como fallback
      if (
        !this.selectedRegisterName ||
        this.selectedRegisterName === 'Sem vínculo com empresa'
      ) {
        await this.changeActiveRegisterName();
      }

      // Forçar detecção de mudanças
      this.cdr.detectChanges();

      await Promise.all([this.getRoles(), this.setAgents(), this.getFunds()]);

      // Verificar novamente se é aprovador após carregar dados
      if (this.authService.user?.active_register) {
        const rolesToApprove = ['assignor', 'provider', 'shareholder', 'fund'];
        const hasApprovePermission = rolesToApprove.some((role) => {
          return this.authService.verifyPermission(`de_can_approve_${role}`);
        });

        this.is_approver =
          this.authService.user.is_superuser || hasApprovePermission;
      }

      // A atualização agora é automática via PendingApprovalService
      // Não precisa chamar manualmente aqui
    } catch (error) {
      console.error('[DashSidebar] getData - erro:', error);
      this.loadingContent = false;
      this.cdr.detectChanges();
    } finally {
      this.isLoadingData = false;

      // Garantir que loadingContent seja false mesmo se getSwitchMainAccount não completar
      if (this.loadingContent) {
        this.loadingContent = false;
        this.cdr.detectChanges();
      }
    }
  }

  async getUserMe(
    updateUser: boolean = true
  ): Promise<NewLoginResponse | null> {
    try {
      // Verificar se o usuário foi limpo antes de fazer a chamada
      const currentUser = this.authService.user;
      if (!currentUser) {
        return null;
      }

      const { data } = await this.api.get<ApiResponse<NewLoginResponse>>({
        route: 'user/me/',
        token: true,
      });

      // Verificar novamente se o usuário ainda existe após a chamada (pode ter sido limpo durante a chamada)
      if (!this.authService.user) {
        return null;
      }

      // Só atualizar o usuário se solicitado (evita loop infinito quando chamado do getData)
      if (updateUser) {
        // Verificar se os dados são diferentes antes de atualizar
        const isDifferent =
          !currentUser ||
          currentUser.id !== data.id ||
          currentUser.active_register?.id !== data.active_register?.id;

        if (isDifferent) {
          this.authService.setUser(data);
          this.storageService.setPermissionType(data.type_permission);
        }
      } else {
        // Atualizar apenas internamente sem emitir evento userChange
        // Isso permite usar os dados sem causar loop
        // Atualizar tanto _user quanto armazenar no storage para garantir acesso
        // MAS só se o usuário ainda existir (não foi limpo durante logout)
        if (this.authService.user) {
          (this.authService as any)._user = data;
          this.storageService.setPermissionType(data.type_permission);
          // Também salvar no storage para garantir que getUser() funcione
          this.storageService.setUser(data);
        }
      }

      return data;
    } catch (error) {
      console.error('Erro ao buscar dados do usuário:', error);
      return null;
    }
  }

  async getPendingCount() {
    try {
      const { data } = await this.api.get<{
        data: {
          department_pending: number;
          total_items: number;
          area?: string;
          by_role?: {
            provider: number;
            assignor: number;
            shareholder: number;
            total: number;
          };
        };
      }>({
        route: 'api/approvals/v3/user_approval/my-area-dashboard/summary/',
        token: true,
      });

      // Usar by_role.total (que é o mesmo valor dos cards) se department_pending não estiver disponível ou for 0
      const departmentPending = data.department_pending ?? 0;
      const totalByRole = data.by_role?.total ?? 0;

      // Se department_pending for 0 mas by_role.total tiver valor, usar by_role.total
      this.pendingCount =
        departmentPending > 0 ? departmentPending : totalByRole;

      // Armazenar a área retornada pela API (já filtrada)
      const rawArea = data.area || '';
      this.userArea = this.filterUserArea(rawArea);

      // Atualizar o currentRole se for usuário comum
      const user = this.authService.user || this.authService.getUser();
      if (this.isCommonCollaborator(user)) {
        this.updateCommonUserRole();
      }
    } catch (error) {
      console.error('Error getting pending count:', error);
      this.pendingCount = 0;
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.openNotify) {
      if (!event.target.className.includes('content-header-profile-icon')) {
        this.openNotify = false;
      }
    }

    if (this.userOptionsOpen) {
      const target = event.target as HTMLElement;
      const clickedInsideContainer =
        this.toggleOptions?.nativeElement.contains(target);
      const clickedInsideDropdown = target.closest('.credentials-options');

      if (!clickedInsideContainer && !clickedInsideDropdown) {
        this.userOptionsOpen = false;
      }
    }
  }

  setUserBasicInfo() {
    const user = this.authService.getUser();

    this.userNacionality = user.nationality?.country ?? null;
    this.userDocument = user.documents?.number
      ? this.maskPipe.transform(user.documents.number, '000.000.000-00')
      : null;

    this.changeBasicInfoForm.patchValue({
      full_name: user.first_name + ' ' + user.last_name,
      email: user.email,
      //   phone_number: user.phone
      //     ? this.maskPipe.transform(user.phone.number, '(00) 00000-0000')
      //     : null,
      phone_ddi: user.phone ? String(user.phone.code) : '55',
    });
  }

  toggleChangePasswordModal() {
    this.userOptionsOpen = false;
    this.changePasswordShow = !this.changePasswordShow;

    if (!this.changePasswordShow) {
      setTimeout(() => {
        this.changePasswordForm.reset();
        this.changePasswordStep = 0;
        this.passwordSubmiting = false;
      }, 500);
    } else {
      // Resetar o formulário quando abrir o modal
      this.changePasswordForm.reset();
      this.changePasswordStep = 0;
      this.passwordSubmiting = false;
    }
  }

  toggleChangeBasicInfoModal() {
    this.userOptionsOpen = false;
    this.changeBasicInfoShow = !this.changeBasicInfoShow;

    if (!this.changeBasicInfoShow) {
      setTimeout(() => {
        this.changeBasicInfoForm.reset();
      }, 500);
    } else {
      this.setUserBasicInfo();
    }
  }

  toggleSearch() {
    this.searchOpen = true;
  }

  async getAccounts(type: string = 'profile', register_id: string = null) {
    try {
      const { data } = await this.api.get<ApiResponse<RegisterUserResponse[]>>({
        route: `api/registration/register_user/`,
        params: {
          type: type,
          register: register_id,
        },
        token: true,
      });

      this.accounts = data
        .sort((a, b) => {
          return (
            new Date(b.register.created_at).getTime() -
            new Date(a.register.created_at).getTime()
          );
        })
        .reverse();

      this.authService.accountsArr = this.accounts;
    } catch (error) {
      console.error(error);
    }
  }

  async getSwitchMainAccount() {
    try {
      const data = await this.api.get<any[]>({
        route: `api/v2/registration/account-switch/`,
        params: {
          type: 'profile',
        },
        token: true,
      });

      const newData = data.sort((a, b) => b.id - a.id).reverse();

      this.visible_accounts = newData;
    } catch (error) {
      console.error('[DashSidebar] getSwitchMainAccount - erro:', error);
    } finally {
      this.loadingContent = false;
    }
  }

  async getSwitchAccounts() {
    try {
      const data = await this.api.get<any[]>({
        route: `api/v2/registration/account-switch/`,
        params: {
          type: 'profile',
          mode: 'list',
        },
        token: true,
      });

      const newData = data.sort((a, b) => b.id - a.id).reverse();

      this.visible_accounts = newData;
      this.authService.visible_accounts = this.visible_accounts;
      this.authService.visibleAccountsFetched.emit();
    } catch (error) {
      console.error(error);
    }
    this.switchAccontsLoading = false;
  }

  async getNotifications() {
    try {
      const res = await this.api.get({
        route: `notifications/`,
        token: true,
      });

      this.notifications = res.data;

      this.haveNewNotifications = this.notifications.some(
        (notification) => notification.read === false
      );
    } catch (error) {
      console.error(error);
    }
  }

  toggleUserOptions(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.userOptionsOpen = !this.userOptionsOpen;
  }

  async handleNotifyClick(notification, idx) {
    try {
      await this.api.put({
        route: `notifications/`,
        token: true,
        params: {
          id: notification.id,
        },
      });

      this.notifications[idx].read = true;

      switch (notification.action) {
        case 'redirect':
          window.open(notification.param, '_blank');
          break;
      }
    } catch (error) {
      console.error(error);
    }
  }

  async markAllAsread() {
    try {
      await this.api.put({
        route: `notifications/`,
        token: true,
      });

      this.notifications.forEach((notification) => {
        notification.read = true;
      });
    } catch (error) {
      console.error(error);
    }
  }

  handleCloseSearching() {
    this.searchOpen = false;
    this.users = [];
    this.searching = false;
    this.form.controls.search.setValue(null);
  }

  onSearchInput(value: string) {
    const trimmedValue = value?.trim() ?? '';
    if (trimmedValue.length > 0) {
      this.currentSearchValue = trimmedValue;
      this.searching = true;
      this.searchSubject.next(trimmedValue);
    } else {
      this.currentSearchValue = '';
      this.searchRequestId++;
      this.users = [];
      this.searching = false;
    }
  }

  handleSearch(event) {
    // if (this.users.length === 1) {
    //   this.redirectUser(0);
    // } else {
    //   this.router.navigateByUrl('/app/dashboard');
    // }

    if (this.users.length >= 1) {
      this.redirectUser(0);
    }

    this.handleCloseSearching();
  }

  async searchUser(value: any) {
    // Validação defensiva: verificar se o valor é válido
    if (value === null || value === undefined) {
      this.users = [];
      this.searching = false;
      return;
    }

    // Converter para string e fazer trim
    const trimmedValue = String(value).trim();
    if (trimmedValue.length === 0) {
      this.users = [];
      this.searching = false;
      return;
    }

    // Incrementar ID da requisição para cancelar requisições antigas
    const requestId = ++this.searchRequestId;
    this.searching = true;
    
    // Atualizar currentSearchValue imediatamente para evitar race conditions
    // Isso garante que verificações posteriores usem o valor correto
    this.currentSearchValue = trimmedValue;

    const executeSearch = async () => {
    try {
      const params = {
        search: trimmedValue,
      };

      const res = await this.api.get<SearchResponse[]>({
        route: `api/v2/registration/search/`,
        params,
        token: true,
      });

      // Verificar se ainda é a busca mais recente ANTES de processar os dados
      // Se uma nova busca foi iniciada, cancelar esta
      if (
        this.currentSearchValue !== trimmedValue ||
        requestId !== this.searchRequestId
      ) {
        // Esta busca foi cancelada por uma busca mais recente
        return;
      }

      /*
      const rolesToFilter = [];
      const roles = [
        'assignor',
        'shareholder',
        'provider',
        'representative',
        'fund',
      ];

      roles.forEach((role) => {
        const slug = `de_can_view_${role}`;
        if (!this.authService.verifyPermission(slug)) {
          rolesToFilter.push(role);
        }
      });

      const filteredData = res.filter((item) => {
        return item.role
          ? !rolesToFilter.includes(item.role)
          : !rolesToFilter.includes(item.type);
      });
      */
      
      const filteredData = res.filter((item) => item.role !== 'admin');

      // Verificar novamente se ainda é a busca mais recente após filtrar
      // Isso previne atualização da UI com dados de uma busca antiga
      if (
        this.currentSearchValue !== trimmedValue ||
        requestId !== this.searchRequestId
      ) {
        return;
      }

      const newUsers: UserProps[] = filteredData.map((approval) => {
        const isRegister =
          approval.fantasy_name === null || approval.fantasy_name === undefined;

        // Determinar o tipo de pessoa
        let personType = '';
        if (approval.fantasy_name !== undefined) {
          personType = 'Fundo';
        } else if (approval.type === 'PF') {
          personType = 'Pessoa Física';
        } else if (approval.type === 'PJ') {
          personType = 'Pessoa Jurídica';
        } else if (approval.type === 'CA') {
          personType = 'CA';
        }

        // Lógica para definir os papéis a serem exibidos:
        // 1) papers (fonte principal)
        // 2) roles (fallback)
        // 3) role/type legado (fallback final)
        let displayRole = '';
        const rolesFromPapers = (approval as any).papers
          ?.map((paper: any) => paper?.role)
          .filter(Boolean);

        const primaryRoles =
          rolesFromPapers && rolesFromPapers.length > 0
            ? rolesFromPapers
            : approval.roles;

        if (primaryRoles && primaryRoles.length > 0) {
          let rolesToDisplay = primaryRoles;

          // Se tiver múltiplos papéis e um deles for representante, remove o representante
          // Exceção: se só tiver representante, exibe ele
          if (rolesToDisplay.length > 1) {
            rolesToDisplay = rolesToDisplay.filter(
              (r: any) => r.applicable !== 'representative'
            );
          }

          // Se o filtro removeu tudo, volta ao conjunto original
          if (rolesToDisplay.length === 0) {
            rolesToDisplay = primaryRoles;
          }

          displayRole = Array.from(
            new Set(
              rolesToDisplay
                .map((r: any) => {
                  const roleName = String(r?.name || '').toUpperCase();
                  const roleSlug = String(r?.slug || '').toUpperCase();
                  const isShareholderFI =
                    r?.applicable === 'shareholder' &&
                    (roleName.includes('FI') || roleSlug.includes('-FI'));

                  if (isShareholderFI) {
                    return 'Cotista Fundo de Investimento';
                  }

                  return r?.applicable_display;
                })
                .filter(Boolean)
            )
          ).join(', ');
        }

        if (!displayRole) {
          // Fallback para lógica antiga
          displayRole = this.formatName(isRegister ? approval.role : 'fund');
        }

        return {
          role: displayRole,
          applicable: isRegister ? approval.role : 'fund',
          id: isRegister ? approval.id : String(approval.id),
          document: this.formatSearchedDocument(approval),
          company_id: approval?.company_id,
          collaborator_id: approval?.collaborator_id,
          name: this.formatSearchedName(approval),
          personType: personType,
          status: approval.status,
          roles: approval.roles,
          rawType: approval.type,
        } as any;
      });

      // Verificar uma última vez antes de atualizar a UI
      // Garante que não atualizamos com dados de uma busca cancelada
      if (
        this.currentSearchValue !== trimmedValue ||
        requestId !== this.searchRequestId
      ) {
        return;
      }

      // Atualizar users e desativar loading apenas se for a busca atual
      this.users = [...newUsers];
      this.searching = false;
    } catch (error) {
      console.error('[DashSidebar] Erro na busca:', {
        searchValue: trimmedValue,
        requestId,
        currentRequestId: this.searchRequestId,
        error
      });
      
      // SEMPRE resetar o estado de loading se esta for a busca mais recente
      // Isso garante que o loading não fique preso em caso de erro
      if (
        this.currentSearchValue === trimmedValue &&
        requestId === this.searchRequestId
      ) {
        this.users = [];
        this.searching = false;
      }
    } finally {
      // Garantia adicional: se esta é a requisição mais recente e ainda está em loading, desativar
      if (requestId === this.searchRequestId && this.searching) {
        this.searching = false;
      }
    }
    };

    executeSearch();
  }

  formatSearchedDocument(approval: SearchResponse) {
    let document = '';

    if (approval.fantasy_name !== undefined) {
      document = this.maskPipe.transform(
        approval.document_number,
        '00.000.000/0000-00'
      );
    } else {
      document =
        approval.type === 'PF'
          ? this.maskPipe.transform(approval.document_number, '000.000.000-00')
          : this.maskPipe.transform(
              approval.document_number,
              '00.000.000/0000-00'
            );
    }

    return document;
  }

  formatSearchedName(approval: SearchResponse) {
    let name = '';

    if (approval.fantasy_name !== undefined) {
      name = approval.fantasy_name;
    } else {
      name = approval.type === 'PF' ? approval.name : approval.name;
    }

    return name;
  }

  formatName(name: string) {
    switch (name) {
      case 'assignor':
        return 'Cedente';
      case 'shareholder':
        return 'Cotista';
      case 'provider':
        return 'Prestador de serviço';
      case 'fund':
        return 'Fundo';
      case 'admin':
        return 'Colaborador';

      default:
        return 'Representante';
    }
  }

  formatDocument(document: any) {
    if (document) {
      if (document.type === 'CNPJ' || document.type === 'cnpj') {
        return document.number.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
          '$1.$2.$3/$4-$5'
        );
      } else {
        return document.number.replace(
          /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
          '$1.$2.$3-$4'
        );
      }
    } else {
      return '';
    }
  }

  toggleNotify() {
    this.openNotify = !this.openNotify;
  }

  handleSetMenu() {
    const user = this.authService.getUser();

    if (user) {
      if (user.is_staff) {
        this.setMenu('ADM');
      } else {
        if (user) {
          const role = user.active_register
            ? user.active_register.register.role
            : user.role;

          const type = role.slug.includes('ADM')
            ? 'ADM'
            : (user.active_register.register.role.slug.split(
                '-'
              )[1] as UserTypes);

          this.setMenu(type);
        }
      }
    }

    this.loadingMenu = false;
  }

  getName(account: any) {
    return account.register.name || '-';
  }

  getRole(account: any) {
    if (!account) {
      return '';
    }

    if (account.register.department) {
      return (
        account.register?.role?.applicable_display +
        ' - ' +
        account.register?.department?.name
      );
    }

    return account.register.role.applicable_display;
  }

  setMenu(type: UserTypes) {
    let newMenu = [];
    const menuItems = [
      {
        title: 'Meu departamento',
        icon: 'fas fa-objects-column',
        route: '/app/dashboard',
        permission: 'de_can_view_my_area',
      },
      {
        title: 'Meus cadastros',
        icon: 'fas fa-users',
        route: '/app/accounts',
        permission: 'de_can_view_my_registers',
      },
      {
        title: 'Convites',
        icon: 'fas fa-user-plus',
        route: '/app/invites',
        permission: 'de_can_view_invites',
      },
      {
        title: 'Cadastros',
        icon: 'fas fa-clipboard',
        route: '/app/registers',
        permission: 'de_can_view_registers',
      },
      {
        title: 'Fundos',
        svg: 'icon-pig',
        route: '/app/funds',
        permission: 'de_can_view_fund',
      },
      {
        title: 'Configurações',
        icon: 'fas fa-cog',
        route: '/app/settings',
        permission: 'de_can_view_configurations',
      },
      {
        title: 'Permissões',
        svg: 'icon-security',
        route: '/app/permissions',
        permission: 'de_can_view_permissions',
      },
      {
        title: 'Minutas',
        icon: 'fas fa-file-contract',
        route: '/app/drafts',
        permission: 'de_can_view_draft_settings',
      },
    ];

    const user = this.authService.user;

    // O menu "Meu departamento" nunca deve mudar de nome para "Meus dados"
    // Sempre usar "Meu departamento" como título fixo

    // Se for master (type_permission === 'master' || type_permission === 'owner' || is_approver === true), mostra todos os menus
    const isMaster = this.isMasterUser(user);
    const isCommonCollaborator = this.isCommonCollaborator(user);

    // Para Colaborador Comum (não master), sempre mostrar os 5 menus específicos
    if (isCommonCollaborator && !isMaster) {
      newMenu.push(
        {
          title: 'Meu departamento',
          icon: 'fas fa-objects-column',
          route: '/app/dashboard',
        },
        {
          title: 'Meus cadastros',
          icon: 'fas fa-users',
          route: '/app/accounts',
        },
        {
          title: 'Convites',
          icon: 'fas fa-user-plus',
          route: '/app/invites',
        },
        {
          title: 'Cadastros',
          icon: 'fas fa-clipboard',
          route: '/app/registers',
        },
        {
          title: 'Fundos',
          svg: 'icon-pig',
          route: '/app/funds',
        }
      );
    } else {
      // Para outros usuários, filtrar por permissões ou mostrar tudo (se master)
      const filteredMenu = isMaster
        ? menuItems // Se for master, mostra todos os menus sem filtrar por permissão
        : menuItems.filter((item) => {
            return this.authService.verifyPermission(item.permission);
          });
      newMenu.push(...filteredMenu);
    }

    if (type === 'PF' || type === 'PJ') {
      const {
        active_register: {
          register: {
            id,
            role: { applicable },
          },
        },
      } = user;

      // Verificar se NÃO é colaborador comum (master ou cedente/prestador/cotista)
      const isCommonCollaboratorCheck = this.isCommonCollaborator(user);
      const isMasterCheck = this.isMasterUser(user);

      // NÃO mostrar "Meu registro" para usuários master/owner
      // Apenas mostrar para cedentes/prestadores/cotistas que não são master/owner
      if (
        !isCommonCollaboratorCheck &&
        !isMasterCheck &&
        (applicable === 'shareholder' ||
          applicable === 'assignor' ||
          applicable === 'provider' ||
          applicable === 'representative')
      ) {
        newMenu.push({
          title: applicable === 'representative' ? 'Meus dados' : 'Meu registro',
          icon: 'fas fa-ballot',
          route: `/app/details/${applicable}/${id}`,
        });
      }
    }

    this.menu = [...newMenu];

    this.authService.navigationPermissions = this.menu;
    this.authService.menuLoadedEvent.emit();
  }

  getActiveRoute(route?: string) {
    if (route) {
      return this.router.url.includes(route);
    }

    return false;
  }

  redirectUser(value) {
    const searched: any = this.users[value];

    const company_id = searched.company_id;
    const collaborator_id = searched.collaborator_id;

    if (company_id && collaborator_id) {
      this.router.navigateByUrl(
        `/app/permissions/companies/${company_id}/user/details/${collaborator_id}`
      );
      this.handleCloseSearching();

      return;
    }

    if (searched.applicable === 'admin') return;

    // Representante: navegar para tela de detalhes
    if (searched.applicable === 'representative') {
      this.handleCloseSearching();
      this.router.navigateByUrl(`/app/details/representative/${searched.id}`);
      return;
    }

    this.handleCloseSearching();

    // Lógica para redirectionamento baseado no status "Em edição"
    let statusText = '';
    if (searched.status) {
      statusText = searched.status.toLowerCase();
      statusText = statusText.charAt(0).toUpperCase() + statusText.slice(1);
    } else {
      statusText = 'Em edição';
    }

    const isEmEdicao =
      statusText === 'Em edicao' ||
      statusText === 'Em edição' ||
      statusText === 'EmEdicao' ||
      statusText === 'Editing';

    if (isEmEdicao) {
      // Verificar se tem múltiplos papéis
      const roles = searched.roles || [];
      const applicableRoles = roles.filter(
        (r) => r.applicable !== 'representative'
      );

      if (applicableRoles.length > 1) {
        // Abrir modal de seleção de papel
        this.selectedUserForRoleSelection = searched;
        this.roleSelectionModal = true;
        return;
      } else {
        // Redirecionar direto para onboarding
        // Se tiver apenas um papel no array roles, usa ele. Se não, usa o active_register logic ou o que já temos.
        const role = applicableRoles.length > 0 ? applicableRoles[0] : null;
        const applicable = role
          ? role.applicable
          : searched.applicable;
        
        // Tentar inferir o type se não vier no search (geralmente vem no rawType que adicionamos)
        // Se role for "shareholder" -> PF ou PJ? O search retorna 'type' (PF/PJ).
        const type = searched.rawType ? searched.rawType.toLowerCase() : 'pf'; // fallback seguro

        this.router.navigate([
            `/signup/${applicable}/${type}/${searched.id}`,
        ]);
        return;
      }
    }

    if (searched.applicable === 'fund') {
      this.router.navigateByUrl(`/app/funds/approval/${searched.id}`);
    } else {
      const url = `/app/details/${searched.applicable}/`;

      if (this.router.url.includes(url)) {
        this.authService.reloadApprovalEvent.emit();
      }

      this.router.navigateByUrl(url + searched.id);
    }
  }

  redirectTo(menuItem: MenuItem) {
    if (!menuItem.children) {
      this.router.navigate([menuItem.route]);
    }
  }

  handleMenuClick(menuItem: MenuItem, event: MouseEvent) {
    event.stopPropagation();
    if (menuItem.children) {
      this.submenu = menuItem.children;
    } else {
      this.router.navigate([menuItem.route]);
      this.submenu = [];
    }
  }

  handleSubmenuClick(menuItem: MenuItem, event: MouseEvent) {
    event.stopPropagation();
    this.router.navigate([menuItem.route]);
    this.submenu = [];
  }

  toggleSwitcher(status?: boolean) {
    if (status) {
      this.switcherOpen = status;
    } else {
      this.switcherOpen = !this.switcherOpen;
    }
  }

  async logoff() {
    this.userOptionsOpen = false;
    // Limpar tudo de forma assíncrona e aguardar conclusão
    await this.authService.clearUser();

    // Verificar uma última vez se tudo foi limpo
    const userStillExists = localStorage.getItem('@app:user');
    const tokenStillExists = localStorage.getItem('@app:token');

    if (userStillExists || tokenStillExists) {
      // Se ainda existir, limpar manualmente
      if (userStillExists) localStorage.removeItem('@app:user');
      if (tokenStillExists) localStorage.removeItem('@app:token');

      // Aguardar um pouco mais para garantir
      await new Promise((resolve) => setTimeout(resolve, 50));
    }

    // Navegar com replaceUrl para evitar problemas de histórico
    this.router.navigateByUrl('/login', { replaceUrl: true });
  }

  toggleNewUserModal() {
    if (this.newUserModal) {
      this.newUserForm.reset();
    }

    this.newUserModal = !this.newUserModal;
  }

  async registerNewUser() {
    this.sendingRequest = true;

    try {
      const selectedRole = this.roles.find(
        (item) => item.id === Number(this.newUserForm.value.role)
      );

      const type = selectedRole.slug.split('-')[1];

      const payload = {
        role: selectedRole.id,
        type,
        interest_fund: this.newUserForm.value.interest_fund,
        status: 'created',
      };

      if (this.newUserForm.value.agent) {
        payload['agent'] = this.newUserForm.value.agent;
      }
      const res = await this.api.post({
        route: 'api/registration/register/',
        token: true,
        body: payload,
      });

      this.toast.show('info', 'Sucesso!', 'Usuário cadastrado com sucesso');

      this.newUserForm.reset();
      this.newUserModal = false;

      this.sendingRequest = false;

      // Redirecionamento direto com os dados que já temos
      const registerId = res.data.id;
      const applicable = selectedRole.applicable;
      const typeLower = type.toLowerCase();

      this.router.navigate([
        `/signup/${applicable}/${typeLower}/${registerId}`,
      ]);
    } catch (error) {
      this.toast.show('error', 'Erro!', 'Erro ao cadastrar usuário');
    }

    this.sendingRequest = false;
  }

  toggleRoleSelectionModal() {
    this.roleSelectionModal = !this.roleSelectionModal;
    if (!this.roleSelectionModal) {
      this.selectedUserForRoleSelection = null;
    }
  }

  selectRoleForEdit(role: any) {
    if (!this.selectedUserForRoleSelection) return;

    const searched = this.selectedUserForRoleSelection;
    const applicable = role.applicable;
    const type = searched.rawType ? searched.rawType.toLowerCase() : 'pf';

    this.toggleRoleSelectionModal();
    
    this.router.navigate([
        `/signup/${applicable}/${type}/${searched.id}`,
    ]);
  }

  async changeActiveRegister(id: number) {
    try {
      await this.api.patch({
        route: `user/me/`,
        token: true,
        body: {
          active_register: id,
        },
      });

      const { data } = await this.api.get<ApiResponse<NewLoginResponse>>({
        route: 'user/me/',
        token: true,
      });

      this.storageService.setPermissionType(data.type_permission);
      this.authService.setUser(data);

      //   let permissionsArr =
      //     data.active_register.permissions_role &&
      //     data.active_register.permissions_role.permissions.length > 0
      //       ? data.active_register.permissions_role.permissions
      //       : permission;

      //   if (data.active_register.register.role.applicable === 'representative') {
      //     const defaultPermissions: Permission[] = permission;

      //     permissionsArr = permissionsArr.concat(defaultPermissions);
      //   }

      //   this.authService.permissions = permissionsArr;
      //   this.storageService.set('permissions', permissionsArr, true);
      this.handleRedirect(id);
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro!', 'Erro ao alterar conta ativa');
    }
  }

  handleRedirect(id: number, visible_accounts: boolean = true) {
    const account = this.isAccounts
      ? this.accounts.find((item) => item.id === id)
      : this.visible_accounts.find((item) => item.id === id);

    const isApprover = account.register.is_approver;
    const applicable = account.register.role.applicable;
    const approvals = account.register.approval;
    const _id = account.register.id;
    const type = account.register?.type?.toLowerCase() || '';

    this.isAccounts = false;

    if (applicable === 'representative' || applicable === 'admin') {
      this.router.navigate(['/app/dashboard']);
      return;
    }

    if (approvals.length > 0) {
      if (isApprover) {
        this.router.navigate(['/app/dashboard']);
      } else {
        this.router.navigate([`/app/details/${applicable}/`, _id]);
      }
    } else {
      this.router.navigate([`/signup/${applicable}/${type}`]);
    }
  }

  /**
   * Formata os roles (papéis) seguindo a ordem de prioridade:
   * 1. Verifica se tem role.applicable_display no nível raiz
   * 2. Se não tiver, verifica active_register.register.roles (array) e exibe separados por "•"
   * 3. Se não tiver nada no array roles, usa active_register.register.role.applicable_display
   */
  formatRolesDisplay(user: NewLoginResponse): string {
    if (!user || !user.active_register) {
      return '';
    }

    const activeRegister = user.active_register.register;

    // 1. Primeiro verifica se tem role.applicable_display no nível raiz (fora do active_register)
    if (user.role && user.role.applicable_display) {
      return user.role.applicable_display;
    }

    // 2. Verifica se tem roles (array) dentro de active_register.register
    // Usando type assertion pois a propriedade roles existe na API mas não está no tipo Register
    const rolesArray = (activeRegister as any).roles;
    if (rolesArray && Array.isArray(rolesArray) && rolesArray.length > 0) {
      const rolesDisplay = rolesArray
        .map((role: any) => role.applicable_display)
        .filter((display: string) => display) // Remove valores vazios
        .join(' • ');

      if (rolesDisplay) {
        return rolesDisplay;
      }
    }

    // 3. Se não tiver nada no array roles, usa o role singular
    if (activeRegister.role && activeRegister.role.applicable_display) {
      return activeRegister.role.applicable_display;
    }

    return '';
  }

  /**
   * Formata o display completo do role incluindo o departamento
   */
  /**
   * Determina se o usuário é Master baseado nas regras:
   * - type_permission === "master" OU type_permission === "owner" OU is_approver === true
   */
  isMasterUser(user: NewLoginResponse): boolean {
    if (!user) {
      return false;
    }
    // Verificação: type_permission === "master" OU type_permission === "owner" OU is_approver === true
    return (
      user.type_permission === 'master' ||
      user.type_permission === 'owner' ||
      user.is_approver === true
    );
  }

  /**
   * Determina se o usuário é Colaborador Comum baseado nas regras:
   * - type_permission === "common" E (department NÃO é null OU role.applicable === "admin")
   */
  isCommonCollaborator(user: NewLoginResponse): boolean {
    if (!user || !user.active_register) {
      return false;
    }
    const activeRegister = user.active_register.register;

    // Verifica se é type_permission === 'common'
    if (user.type_permission !== 'common') {
      return false;
    }

    // É Colaborador Comum se:
    // 1. Tem department não nulo, OU
    // 2. role.applicable === 'admin' (mesmo sem department)
    return (
      activeRegister.department !== null ||
      activeRegister.role?.applicable === 'admin'
    );
  }

  /**
   * Verifica se o usuário é cotista, cedente ou prestador de serviço
   * Retorna true se for um desses 3 tipos de perfil
   */
  isAssignorProviderOrShareholder(): boolean {
    const user = this.authService.user || this.authService.getUser();
    if (!user || !user.active_register) {
      return false;
    }

    const activeRegister = user.active_register.register;
    const roleApplicable = activeRegister.role?.applicable;

    // Verifica se é cotista, cedente ou prestador de serviço
    return (
      roleApplicable === 'shareholder' ||
      roleApplicable === 'assignor' ||
      roleApplicable === 'provider'
    );
  }

  /**
   * Verifica se o usuário atual é Master usando o authService
   * Usado no template para controlar exibição de elementos
   */
  isMasterUserForDisplay(): boolean {
    return this.authService.isMasterUser();
  }

  /**
   * Verifica se o usuário atual é Colaborador Comum usando o authService
   * Usado no template para controlar exibição de elementos
   */
  isCommonCollaboratorForDisplay(): boolean {
    return this.authService.isCommonCollaborator();
  }

  /**
   * Verifica se o usuário atual é Master OU Colaborador Comum
   * Usado no template para controlar exibição de elementos (busca, botões de aprovação, etc)
   */
  isMasterOrCommonUser(): boolean {
    return (
      this.authService.isMasterUser() || this.authService.isCommonCollaborator()
    );
  }

  formatRoleWithDepartment(user: NewLoginResponse): string {
    const roleDisplay = this.formatRolesDisplay(user);

    if (!user || !user.active_register) {
      return roleDisplay;
    }

    const activeRegister = user.active_register.register;
    const department = activeRegister.department?.name;

    if (roleDisplay && department) {
      return `${roleDisplay} - ${department}`;
    } else if (roleDisplay) {
      return roleDisplay;
    } else if (department) {
      return department;
    }

    return '';
  }

  /**
   * Filtra a área do usuário removendo referências a "Acesso a todos" ou "Usuário Master"
   * Retorna string vazia se a área contiver esses textos
   */
  private filterUserArea(area: string): string {
    if (!area || !area.trim()) {
      return '';
    }

    const trimmedArea = area.trim();
    
    // Se contém "Acesso a todos" ou "Todos (Usuário Master)" ou "Usuário Master", retornar vazio
    if (
      trimmedArea.includes('Acesso a todos') ||
      trimmedArea.includes('Todos (Usuário Master)') ||
      trimmedArea.includes('Usuário Master')
    ) {
      return '';
    }

    return trimmedArea;
  }

  /**
   * Atualiza o currentRole para usuário comum incluindo a área quando disponível
   */
  updateCommonUserRole(): void {
    // Filtrar userArea para remover referências a "Acesso a todos" ou "Usuário Master"
    const filteredArea = this.filterUserArea(this.userArea);
    
    if (filteredArea && filteredArea.trim()) {
      this.currentRole = `Usuário Comum • ${filteredArea}`;
    } else {
      this.currentRole = 'Usuário Comum';
    }
  }

  /**
   * Atualiza os valores de exibição diretamente com os dados do usuário
   */
  updateRegisterDisplay(user: NewLoginResponse) {
    if (!user) {
      this.selectedRegisterName = 'Sem vínculo com empresa';
      this.currentRole = '';
      return;
    }

    // Verificação primária: type_permission === "master" OU type_permission === "owner"
    // Se for master ou owner, sempre mostrar como "Usuário Master"
    if (this.isMasterUser(user)) {
      this.selectedRegisterName =
        UIDefaultTheme.brand.company_name || UIDefaultTheme.brand.name;
      this.currentRole = 'Usuário Master';
      return;
    }

    // Se não tiver active_register, não pode continuar
    if (!user.active_register) {
      this.selectedRegisterName = 'Sem vínculo com empresa';
      this.currentRole = '';
      return;
    }

    const activeRegister = user.active_register.register;

    // Verificar se é Colaborador Comum (common + department não null)
    if (this.isCommonCollaborator(user)) {
      this.selectedRegisterName =
        UIDefaultTheme.brand.company_name || UIDefaultTheme.brand.name;
      
      // Tentar obter a área do summary atual do serviço se ainda não tiver
      const currentSummary = this.pendingApprovalService.getCurrentSummary();
      if (currentSummary?.area && !this.userArea) {
        const rawArea = currentSummary.area;
        this.userArea = this.filterUserArea(rawArea);
      }
      
      // Se ainda não tiver userArea, chamar a API diretamente para carregar
      if (!this.userArea) {
        this.getPendingCount();
      }
      
      this.updateCommonUserRole();
      return;
    }

    // Se type_permission é common mas department é null, é cedente/prestador/cotista
    // Ou se não é colaborador, mostrar o papel do role
    this.selectedRegisterName =
      activeRegister.name || 'Sem vínculo com empresa';
    this.currentRole = this.formatRolesDisplay(user);

    // Configurar agentes se for provider
    if (
      activeRegister.role?.applicable === 'provider' &&
      activeRegister.agent
    ) {
      this.selectedRegisterRoles = activeRegister.agent.map((item: any) => {
        return {
          label: item.name,
          value: String(item.id),
        };
      });
    }

    // company é um objeto Company, precisamos do ID numérico
    this.companyId = activeRegister.company?.id || null;

    this.hasCompanyPermission =
      this.companyId &&
      this.authService.verifyPermission(['de_can_view_companies']);
  }

  changeActiveRegisterName() {
    // Usar this.authService.user diretamente para garantir que pegue os dados atualizados
    const user = this.authService.user || this.authService.getUser();

    // Verificação primária: type_permission === "master" OU type_permission === "owner"
    // Se for master ou owner, sempre mostrar como "Usuário Master"
    if (this.isMasterUser(user)) {
      this.selectedRegisterName =
        UIDefaultTheme.brand.company_name || UIDefaultTheme.brand.name;
      this.currentRole = 'Usuário Master';
      return;
    }

    if (user && user.active_register) {
      const activeRegister = user.active_register.register;

      // Verificar se é Colaborador Comum (common + department não null)
      if (this.isCommonCollaborator(user)) {
        this.selectedRegisterName =
          UIDefaultTheme.brand.company_name || UIDefaultTheme.brand.name;
        
        // Tentar obter a área do summary atual do serviço se ainda não tiver
        const currentSummary = this.pendingApprovalService.getCurrentSummary();
        if (currentSummary?.area && !this.userArea) {
          const rawArea = currentSummary.area;
          this.userArea = this.filterUserArea(rawArea);
        }
        
        // Se ainda não tiver userArea, chamar a API diretamente para carregar
        if (!this.userArea) {
          this.getPendingCount();
        }
        
        this.updateCommonUserRole();
      }
      // Se type_permission é common mas department é null, é cedente/prestador/cotista
      // Ou se não é colaborador, mostrar o papel do role
      else {
        this.selectedRegisterName =
          activeRegister.name || 'Sem vínculo com empresa';
        this.currentRole = this.formatRoleWithDepartment(user);
      }

      // Configurar agentes se for provider
      if (
        activeRegister.role?.applicable === 'provider' &&
        activeRegister.agent
      ) {
        this.selectedRegisterRoles = activeRegister.agent.map((item: any) => {
          return {
            label: item.name,
            value: String(item.id),
          };
        });
      }

      // Tentar buscar do visible_accounts para manter compatibilidade com código existente
      let accountFromVisible = this.visible_accounts.find(
        (item) => item.id === user.active_register?.id
      );

      if (accountFromVisible) {
        this.selectedRegister = accountFromVisible;
        this.selectedRegisterDocument = this.maskPipe.transform(
          accountFromVisible.register.document_number,
          activeRegister.type === 'PF' ? '000.000.000-00' : '00.000.000/0000-00'
        );

        this.companyId = accountFromVisible.register.company
          ? accountFromVisible.register.company_id
          : null;
      } else {
        // Se não encontrar no visible_accounts, usar dados do active_register
        this.selectedRegisterDocument = '';
        // company é um objeto Company, precisamos do ID numérico
        this.companyId = activeRegister.company?.id || null;
      }

      this.hasCompanyPermission =
        this.companyId &&
        this.authService.verifyPermission(['de_can_view_companies']);
    } else {
      // Fallback para quando não tem active_register
      let activeRegister = this.visible_accounts.find(
        (item) => item.id === user?.active_register?.id
      );

      activeRegister = activeRegister ?? this.visible_accounts[0];

      if (activeRegister) {
        this.selectedRegister = activeRegister;
        this.currentRole = this.getRole(activeRegister);

        this.selectedRegisterName =
          activeRegister.register.company &&
          activeRegister.register.company.length > 0
            ? activeRegister.register.company
            : activeRegister.register.name;

        this.selectedRegisterDocument = this.maskPipe.transform(
          activeRegister.register.document_number,
          activeRegister.register.type === 'PF'
            ? '000.000.000-00'
            : '00.000.000/0000-00'
        );

        this.companyId = activeRegister.register.company
          ? activeRegister.register.company_id
          : null;

        this.hasCompanyPermission =
          this.companyId &&
          this.authService.verifyPermission(['de_can_view_companies']);
      }
    }
  }

  async getRoles() {
    const res = await this.api.get<ApiResponse<Role[]>>({
      route: 'role/',
    });

    const { data } = res;

    this.roles = data;

    const userRoles = data
      .filter(
        (_item) =>
          (_item.applicable === 'assignor' ||
            _item.applicable === 'provider' ||
            _item.applicable === 'shareholder') &&
          !_item.slug.includes('REPRESENTATIVE')
      )
      .sort((a, b) => {
        if (a.applicable_display < b.applicable_display) {
          return -1;
        }
        if (a.applicable_display > b.applicable_display) {
          return 1;
        }
        return 0;
      })
      .map((item) => {
        return {
          label: `${item.applicable_display} - ${item.name}`,
          value: String(item.id),
        };
      });

    const temporarySlugsToFilter = [
      'ASSIGNOR-PJ-FI',
      'SHAREHOLDER-PJ-IF',
      'SHAREHOLDER-PF-PFNR',
      'SHAREHOLDER-PJ-PJNR',
    ];

    this.primaryRoleOptions = userRoles.filter((item) => {
      return !temporarySlugsToFilter.includes(
        data.find((role) => role.id === Number(item.value)).slug
      );
    });
  }

  async setAgents() {
    try {
      const res = await this.api.get({
        route: 'api/registration/agent/',
        token: true,
      });

      this.roleOptions = res.map((item: any) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    } catch (error) {
      console.warn(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
  }

  async getFunds() {
    try {
      const res = await this.api.get({
        route: 'api/registration/fund',
        token: true,
      });

      const filteredArr = Utils.filterRepeatedValues(res.funds, 'id');

      const funds = filteredArr.map((fund: any) => {
        return {
          label: fund.name,
          value: fund.id,
        };
      });

      this.fundOptions = funds;
    } catch (error) {
      this.toast.show('error', 'Erro!', 'Erro ao carregar fundos de interesse');
    }
  }

  getUserInitials(string) {
    return string
      .toUpperCase()
      .replace(/[^\w\s]/gi, '')
      .split(' ')
      .slice(0, 2)
      .map((word: string) => word.charAt(0))
      .join('');
  }

  getSelectedAccountInitials(label: string | string[]) {
    if (Array.isArray(label)) {
      label = label[0];
    }

    return label
      .toUpperCase()
      .replace(/[^\w\s]/gi, '')
      .split(' ')
      .slice(0, 2)
      .map((word: string) => word.charAt(0))
      .join('');
  }

  getAccountInitials(item: any) {
    // if (
    //   item.approval.length == 0 &&
    //   item.role.applicable !== 'representative'
    // ) {
    //   return '-';
    // }

    return item.register.name
      .toUpperCase()
      .replace(/[^\w\s]/gi, '')
      .split(' ')
      .slice(0, 2)
      .map((word: string) => word.charAt(0))
      .join('');
  }

  hasNumber(str: string) {
    return /\d/.test(str);
  }

  hasLowerCase(str: string) {
    return str.toUpperCase() !== str;
  }

  hasUpperCase(str: string) {
    return str.toLowerCase() !== str;
  }

  hasSpecialCharacter(str: string) {
    return /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(str);
  }

  passwordStrength(): number[] {
    const password = this.changePasswordForm.get('password')?.value ?? '';

    const strengthSteps = [];

    if (password !== '') strengthSteps.push(0);
    if (password.length >= 8) strengthSteps.push(1);
    if (this.hasNumber(password)) strengthSteps.push(2);
    if (this.hasLowerCase(password) && this.hasUpperCase(password))
      strengthSteps.push(3);
    if (this.hasSpecialCharacter(password)) strengthSteps.push(4);

    return strengthSteps;
  }

  passwordStrengthPercentage(): number {
    return (100 * this.passwordStrength().length) / 5;
  }

  passwordStrengthText(): string {
    const percentage = this.passwordStrengthPercentage();

    if (percentage > 60 && percentage < 90) {
      return 'Sua senha precisa melhorar';
    } else if (percentage >= 90) {
      return 'Sua senha parece bem segura';
    }

    return 'Sua senha está fraca';
  }

  handleSendPassword() {
    if (this.changePasswordStep === 0) {
      this.validatePassword();
    }

    if (this.changePasswordStep === 1) {
      this.changePassword();
    }
  }

  async validatePassword() {
    this.passwordSubmiting = true;

    const password = this.changePasswordForm.get('current_password').value;
    const username = this.authService.user.username;

    try {
      await this.api.post<ApiResponse<NewLoginResponse>>({
        route: 'new-login/',
        body: { username, password },
      });

      this.changePasswordStep = 1;
    } catch (error: any) {
      console.warn(error);

      this.toast.show('error', 'Erro', 'A senha atual está incorreta');

      this.changePasswordForm.controls.current_password.setErrors({
        incorrect: true,
      });
    }

    this.passwordSubmiting = false;
  }
  async changePassword() {
    this.passwordSubmiting = true;

    const current_password =
      this.changePasswordForm.get('current_password').value;
    const password = this.changePasswordForm.get('password').value;
    const confirm_password =
      this.changePasswordForm.get('confirm_password').value;

    try {
      await this.api.patch({
        route: 'new-password/me/',
        body: {
          password,
          confirm_password,
          current_password,
        },
      });

      this.toast.show('info', 'Sucesso!', 'Senha alterada com sucesso');
      this.toggleChangePasswordModal();
    } catch (error: any) {
      console.warn(error);

      this.toast.show(
        'error',
        'Erro',
        'Não foi possível alterar a senha, tente novamente'
      );
    }
    this.passwordSubmiting = false;
  }
  handleDisable() {
    if (this.changePasswordStep === 0) {
      return (
        this.changePasswordForm.get('current_password').invalid ||
        this.passwordSubmiting
      );
    } else {
      return (
        this.changePasswordForm.get('password').invalid ||
        this.changePasswordForm.get('confirm_password').invalid ||
        this.changePasswordForm.hasError('passwordsMismatch') ||
        this.passwordSubmiting
      );
    }
  }

  handleBasicInfoDisable() {
    return this.changeBasicInfoForm.invalid || this.basicInfoSubmiting;
  }

  async changeBasicInfo() {
    try {
      this.basicInfoSubmiting = true;

      const {
        email,
        // phone_number,
        full_name,
        phone_ddi,
      } = this.changeBasicInfoForm.value;

      const first_name = full_name.split(' ')[0];
      const last_name = full_name.split(' ').slice(1).join(' ');

      await this.api.patch({
        route: `user/me/`,
        body: {
          email,
          //   phone: {
          //     code: Number(phone_ddi),
          //     number: Utils.onlyNumbers(phone_number),
          //   },
          first_name,
          last_name,
        },
      });

      this.toast.show(
        'info',
        'Sucesso!',
        'Informações básicas alteradas com sucesso'
      );

      this.userCredentials = {
        email: email,
        name: full_name,
      };

      const user = {
        ...this.authService.user,
        email,
        first_name,
        last_name,
        // phone: {
        //   ...this.authService.user.phone,
        //   code: Number(phone_ddi),
        //   number: Utils.removeSpecialChars(phone_number),
        // },
      };

      this.authService.setUser(user);
      this.toggleChangeBasicInfoModal();
    } catch (error) {
      this.toast.show('error', 'Erro!', 'Erro ao alterar informações básicas');
    } finally {
      this.basicInfoSubmiting = false;
    }
  }

  toggleRoleModal() {
    this.roleModal = !this.roleModal;

    if (this.roleModal) {
      const newRoleOptions = this.roleOptions.filter((item) => {
        return (
          this.selectedRegisterRoles.findIndex(
            (agent) => Number(agent.value) === item.value
          ) === -1
        );
      });

      this.filteredRoleOptions = newRoleOptions;
    }

    setTimeout(() => {
      this.roleForm.reset();
    }, 500);
  }

  renderRoles() {
    return this.selectedRegisterRoles.map((item) => item.label).join(', ');
  }

  async addAgentRole() {
    try {
      const payload = [
        ...this.selectedRegisterRoles.map((item) => Number(item.value)),
        ...this.roleForm.controls.role.value,
      ];

      await this.api.patch<ApiResponse<Register>>({
        route: `api/registration/register/${this.selectedRegister.register.id}/`,
        token: true,
        body: {
          agent: payload,
        },
      });

      this.toast.show('info', 'Sucesso!', 'Papel adicionado com sucesso');

      const roles = this.roleForm.controls.role.value.map((item) => {
        return {
          label: this.roleOptions.find((role) => role.value === item).label,
          value: String(item),
        };
      });

      this.selectedRegisterRoles = [...this.selectedRegisterRoles, ...roles];

      this.filteredRoleOptions = this.filteredRoleOptions.filter(
        (item) => !this.roleForm.controls.role.value.includes(item.value)
      );

      this.toggleRoleModal();
    } catch (error) {
      this.toast.show('error', 'Erro!', 'Erro ao adicionar papel');
    }
  }

  redirectToCompanyDetails() {
    if (
      this.authService.user.active_register?.register?.company &&
      this.authService.verifyPermission(['de_can_view_companies'])
    ) {
      this.router.navigateByUrl(
        `app/permissions/companies/details/${this.authService.user.active_register?.register?.company}`
      );
    }
  }

  // Verifica se o usuário pode clicar no nome da empresa (apenas master)
  get canClickAccountName(): boolean {
    const user = this.authService.user;
    if (!user) return false;

    // Apenas master pode clicar no nome da empresa
    return this.isMasterUser(user);
  }

  /**
   * Retorna o texto do tooltip do badge de aprovações pendentes
   * Se for master, retorna "Cadastros aguardando aprovação"
   * Caso contrário, retorna "Cadastros aguardando sua aprovação"
   */
  get pendingApprovalTooltipText(): string {
    const user = this.authService.user || this.authService.getUser();
    if (this.isMasterUser(user)) {
      return 'Cadastros aguardando aprovação';
    }
    return 'Cadastros aguardando sua aprovação';
  }

  /**
   * Retorna apenas o primeiro nome (primeira palavra) do nome completo
   */
  get firstName(): string {
    if (!this.userCredentials.name || !this.userCredentials.name.trim()) {
      return '';
    }
    return this.userCredentials.name.trim().split(' ')[0];
  }

  handleAccountNameClick(event: MouseEvent) {
    // Se não pode clicar, não faz nada
    if (!this.canClickAccountName) {
      return;
    }

    event.stopPropagation();

    // Se for colaborador (master, owner, common), redireciona para /app/company
    const user = this.authService.user;
    // Verificar se é Master ou Colaborador Comum
    const isMaster = this.isMasterUser(user);
    const isCommonCollaborator = this.isCommonCollaborator(user);

    if (isMaster || isCommonCollaborator) {
      this.router.navigate(['/app/company']);
    } else if (this.hasCompanyPermission) {
      this.redirectToCompanyDetails();
    } else {
      // Fallback: verificar se tem active_register com company e permissão
      if (
        this.authService.user.active_register?.register?.company &&
        this.authService.verifyPermission(['de_can_view_companies'])
      ) {
        this.redirectToCompanyDetails();
      } else {
        this.toggleSwitcher();
      }
    }
  }

  passwordsMatchValidator(formGroup: any) {
    const password = formGroup.get('password')?.value;
    const confirmPassword = formGroup.get('confirm_password')?.value;
    return password === confirmPassword ? null : { passwordsMismatch: true };
  }

  passwordsMatch(): boolean {
    const password = this.changePasswordForm.get('password')?.value;
    const confirmPassword =
      this.changePasswordForm.get('confirm_password')?.value;
    return (
      password === confirmPassword && password !== '' && confirmPassword !== ''
    );
  }

  showPasswordMismatchError(): boolean {
    const confirmPasswordControl =
      this.changePasswordForm.get('confirm_password');
    return (
      confirmPasswordControl?.touched &&
      confirmPasswordControl?.value !== '' &&
      this.changePasswordForm.hasError('passwordsMismatch')
    );
  }

  ngOnDestroy(): void {
    // Cleanup de todas as subscrições para evitar memory leaks
    if (this.pendingApprovalSubscription) {
      this.pendingApprovalSubscription.unsubscribe();
    }
    
    if (this.searchSubjectSubscription) {
      this.searchSubjectSubscription.unsubscribe();
    }
    
    if (this.searchValueChangesSubscription) {
      this.searchValueChangesSubscription.unsubscribe();
    }
    
    // Completar o subject para liberar recursos
    this.searchSubject.complete();
  }

  checkApprovalRoute(): void {
    try {
      const url = this.router.url;
      // Verifica se a URL contém rotas de approval
      const isApproval =
        url.includes('/approval/') ||
        url.includes('/fund/approval/') ||
        (url.includes('/details/') &&
          (url.includes('/assignor/') ||
            url.includes('/shareholder/') ||
            url.includes('/provider/')));

      this.isApprovalRoute = isApproval;
      this.cdr.detectChanges();
    } catch (error) {
      // Log do erro mas não relança - navegação não é operação crítica
      // e erros aqui não devem quebrar o subscription do router
      console.error('[DashSidebar] checkApprovalRoute - ERRO:', error);
      // Define um valor padrão seguro em caso de erro
      this.isApprovalRoute = false;
    }
  }
}
